import {
  DateField,
  EmailField,
  Show,
  TabbedShowLayout,
  TextField,
  Tab,
  Datagrid,
  useRecordContext, ListContextProvider, Pagination, useListController
} from 'react-admin';

const WineRequestsList = () => {

  const record = useRecordContext();

  const listContext = useListController({
    resource: "admin/users/wine/requests",
    perPage: 10,
    sort: {field: "searchedAt", order: "DESC"},
    filter: {userId: record?.id},
  });

  return (
    <ListContextProvider value={listContext}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="searchedAt"/>
        <TextField source="wineName"/>
        <TextField source="producer"/>
        <TextField source="vintage"/>
        <TextField source="grapes"/>
        <TextField source="type"/>
        <TextField source="region"/>
        <TextField source="country"/>
        <TextField source="primaryAromas"/>
        <TextField source="foodPairings"/>
      </Datagrid>
      <Pagination/>
    </ListContextProvider>
  );
};

export const UserShow = () => (
  <Show>
    <TabbedShowLayout>
      {/* Details tab */}
      <Tab label="Details">
        <TextField source="id"/>
        <EmailField source="email"/>
        <TextField source="name"/>
        <TextField source="lastName"/>
        <TextField source="status"/>
        <DateField source="createdAt"/>
      </Tab>

      {/* Wine Requests tab */}
      <Tab label="Wine Requests">
        <WineRequestsList/>
      </Tab>
    </TabbedShowLayout>
  </Show>
);
